export default __webpack_public_path__ + "static/media/landingPage.54b67cd6.png";